import * as Sentry from '@sentry/angular';
/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { appVersion } from './app/app-version';

Sentry.init({
  dsn: 'https://ee0de3e752c0b21a8b3145b9f3ea655d@o250147.ingest.us.sentry.io/4511586963292160',
  release: appVersion,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      mask: [
        '.sentry-mask',
        '[data-sentry-mask]',
        'input',
        'textarea',
        '[formControlName]',
        '.form-control',
      ],

      block: [
        '.sentry-block',
        '[data-sentry-block]',
      ],

      ignore: [
        '.sentry-ignore',
        '[data-sentry-ignore]',
      ],
    }),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1,
  enableLogs: true,
  sendDefaultPii: true,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
